const Softwares: React.FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="4" fill="#E8FEF3" />
      <rect
        x="18.4004"
        y="26.2246"
        width="13.6306"
        height="13.6306"
        rx="2.75"
        transform="rotate(11.6554 18.4004 26.2246)"
        fill="#00A868"
      />
      <path
        d="M19.3551 31.2162C20.0373 29.6783 21.9281 29.108 23.3469 30.0122L30.5863 34.6259L29.5531 39.6343C29.2463 41.1218 27.7917 42.0789 26.3043 41.772L18.9897 40.2632C17.2718 39.9088 16.3202 38.0583 17.0315 36.4549L19.3551 31.2162Z"
        fill="#1D232A"
      />
      <rect
        x="15.3203"
        y="25.5889"
        width="13.6306"
        height="13.6306"
        rx="2.75"
        transform="rotate(11.6554 15.3203 25.5889)"
        fill="#00D483"
      />
      <path
        d="M28.0332 31.4238L30.902 33.0862L30.7961 33.5996L27.9273 31.9373L28.0332 31.4238Z"
        fill="#1D232A"
      />
      <path
        d="M27.8223 32.4512L30.6911 34.1135L30.5852 34.627L27.7164 32.9646L27.8223 32.4512Z"
        fill="#1D232A"
      />
      <rect
        x="21.4609"
        y="10.6338"
        width="13.6306"
        height="13.6306"
        rx="2.75"
        transform="rotate(11.6554 21.4609 10.6338)"
        fill="#00A868"
      />
      <path
        d="M22.4157 15.6264C23.0978 14.0885 24.9887 13.5182 26.4074 14.4224L33.6468 19.0361L32.6137 24.0445C32.3068 25.5319 30.8523 26.489 29.3648 26.1822L22.0502 24.6734C20.3323 24.319 19.3808 22.4685 20.092 20.865L22.4157 15.6264Z"
        fill="#1D232A"
      />
      <rect
        x="18.3809"
        y="9.99805"
        width="13.6306"
        height="13.6306"
        rx="2.75"
        transform="rotate(11.6554 18.3809 9.99805)"
        fill="#00D483"
      />
      <path
        d="M31.0938 15.833L33.9626 17.4954L33.8567 18.0088L30.9878 16.3465L31.0938 15.833Z"
        fill="#1D232A"
      />
      <path
        d="M30.8828 16.8604L33.7517 18.5227L33.6457 19.0362L30.7769 17.3738L30.8828 16.8604Z"
        fill="#1D232A"
      />
      <rect
        x="38.084"
        y="21.9922"
        width="13.6306"
        height="13.6306"
        rx="2.75"
        transform="rotate(11.6554 38.084 21.9922)"
        fill="#00A868"
      />
      <path
        d="M39.0348 26.9848C39.717 25.4469 41.6078 24.8766 43.0266 25.7808L50.2659 30.3945L49.2328 35.4029C48.926 36.8903 47.4714 37.8474 45.984 37.5406L38.6694 36.0318C36.9514 35.6774 35.9999 33.8269 36.7111 32.2234L39.0348 26.9848Z"
        fill="#1D232A"
      />
      <rect
        x="35.0039"
        y="21.3564"
        width="13.6306"
        height="13.6306"
        rx="2.75"
        transform="rotate(11.6554 35.0039 21.3564)"
        fill="#00D483"
      />
      <path
        d="M47.7168 27.1914L50.5856 28.8538L50.4797 29.3672L47.6109 27.7049L47.7168 27.1914Z"
        fill="#1D232A"
      />
      <path
        d="M47.5059 28.2188L50.3747 29.8811L50.2688 30.3946L47.3999 28.7322L47.5059 28.2188Z"
        fill="#1D232A"
      />
      <rect
        x="35.0586"
        y="37.8965"
        width="13.6306"
        height="13.6306"
        rx="2.75"
        transform="rotate(11.6554 35.0586 37.8965)"
        fill="#00A868"
      />
      <path
        d="M36.0114 42.8901C36.6935 41.3522 38.5844 40.7818 40.0031 41.686L47.2425 46.2998L46.2094 51.3081C45.9026 52.7956 44.448 53.7527 42.9605 53.4459L35.646 51.937C33.928 51.5827 32.9765 49.7322 33.6877 48.1287L36.0114 42.8901Z"
        fill="#1D232A"
      />
      <rect
        x="31.9766"
        y="37.2617"
        width="13.6306"
        height="13.6306"
        rx="2.75"
        transform="rotate(11.6554 31.9766 37.2617)"
        fill="#00D483"
      />
      <path
        d="M44.6895 43.0957L47.5583 44.7581L47.4524 45.2715L44.5835 43.6091L44.6895 43.0957Z"
        fill="#1D232A"
      />
      <path
        d="M44.4805 44.123L47.3493 45.7854L47.2434 46.2989L44.3746 44.6365L44.4805 44.123Z"
        fill="#1D232A"
      />
    </svg>
  );
};

export default Softwares;
